var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#DDEBFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5698_835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2.41667C4 2.18655 4.19898 2 4.44444 2H13.7778V7C13.7778 7.46023 14.1757 7.83333 14.6667 7.83333H20V21.5833C20 21.8134 19.801 22 19.5556 22H4.44444C4.19898 22 4 21.8134 4 21.5833V2.41667Z",
    fill: "#4086F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 2.41667C4 2.18655 4.16281 2 4.36364 2H12V7C12 7.46023 12 7.62987 12 7.90111V11V19.7038C12 19.9339 12 21.6217 12 22H4.36364C4.16281 22 4 21.8134 4 21.5833V2.41667Z",
    fill: "#292929",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7778 2L16.8889 4.91667L20 7.83333H14.6667C14.1757 7.83333 13.7778 7.46023 13.7778 7V2Z",
    fill: "#80AEF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5698_835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white",
    transform: "translate(4 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/Doc.545d1dde9e91993fcb496a32dc5eb462.svg";
export { ForwardRef as ReactComponent };